import { Types } from '../../../../../actions/dashboards'
import { Types as ProductsTypes } from '../../../../../actions/products'
import { Metrics } from '../../../../../constants/Dashboards'
import { Product } from '../../../../products'
import buildAsyncStatReducer from './../../asyncStatReducer'
import { InteractionsProductPayload, WFHInteractionsProducts } from './types'

/**
 * WFH Interactions Per Product reducer
 */
const wfhInteractionsPerProduct = buildAsyncStatReducer({
    key: Metrics.WFH_INTERACTIONS_PRODUCTS,
    types: {
        request: Types.DASHBOARD_WFH_INTERACTIONS_PRODUCT.request,
        success: Types.DASHBOARD_WFH_INTERACTIONS_PRODUCT.success,
        failure: Types.DASHBOARD_WFH_INTERACTIONS_PRODUCT.failure,
    },
    transform: (state, { payload }): WFHInteractionsProducts => {
        const typedPayload = (payload as InteractionsProductPayload[]) || []
        const playlistMap: Record<string, number> = typedPayload.reduce(
            (carry, { product, count }) => ({
                ...carry,
                [product]: count,
            }),
            {}
        )
        const sortedPlaylistsList: string[] = Object.keys(playlistMap).sort((a: string, b: string): number => playlistMap[b] - playlistMap[a])

        return {
            values: sortedPlaylistsList.map((p) => playlistMap[p]),
            labels: sortedPlaylistsList,
            total: sortedPlaylistsList.length,
            perc: null,
            name: 'dashboard-count-interactions',
        }
    },
})

/**
 * WFH Interactions Per Product reducer
 */
const wfhProductDetails = buildAsyncStatReducer({
    key: Metrics.WFH_INTERACTIONS_PRODUCTS,
    types: {
        request: ProductsTypes.DCG_PRODUCT_INFORMATION.request,
        success: ProductsTypes.DCG_PRODUCT_INFORMATION.success,
        failure: ProductsTypes.DCG_PRODUCT_INFORMATION.failure,
    },
    transform: (state: any, { payload, meta }): WFHInteractionsProducts | undefined => {
        if (meta.secondaryType !== Types.DASHBOARD_WFH_INTERACTIONS_PRODUCT.success) {
            return
        }

        const products: Product[] = payload?.data?.getProducts || []
        const { stats } = state
        const data: WFHInteractionsProducts = stats[Metrics.WFH_INTERACTIONS_PRODUCTS]

        if (!data) {
            return
        }

        const oldDataLabels: string[] = data.labels
        const newDataLabels: string[] = oldDataLabels.map((sku: string): string => {
            const productData: Product | undefined = products.find((product: Product): boolean => product.sku === sku)

            if (productData) {
                const title: string = productData.title.en_gb
                return `${sku} ${title}`
            }

            return sku
        })

        return {
            ...data,
            labels: newDataLabels,
        }
    },
})

export default wfhInteractionsPerProduct

export { wfhProductDetails }
